import { Form } from '@/components/atoms/Form'
import { WithViewModelProps } from '@/shared/types/components'
import {
    Modal,
    LoadingOverlay,
    Stack,
    Flex,
    TextInput,
    Button,
} from '@mantine/core'
import {
    Phone,
} from 'lucide-react'
import React from 'react'
import { Controller } from 'react-hook-form'
import { useViewModel } from './CustomerShipping.vm'

const CreateShippingAddressModal = ({
    viewModel,
}: WithViewModelProps<typeof useViewModel>) => {
    return (
        <Modal
            zIndex={1000}
            title={
                viewModel.optionsForm.getValues('mode') === 'CREATE'
                    ? 'Ajouter une adresse de livraison'
                    : "Modifier l'adresse de livraison"
            }
            opened={viewModel.optionsForm.watch('isModalOpen')}
            onClose={() => viewModel.optionsForm.setValue('isModalOpen', false)}
        >
            <LoadingOverlay visible={viewModel.form.formState.isSubmitting} />
            <Form onSubmit={viewModel.onFormSubmit}>
                <Stack spacing="sm">
                    <Flex gap="sm">
                        <Controller
                            control={viewModel.form.control}
                            name="first_name"
                            render={({ field, fieldState, formState }) => (
                                <TextInput
                                    label="Prénom"
                                    placeholder="ex. Pierre"
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={formState.isSubmitting}
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            control={viewModel.form.control}
                            name="last_name"
                            render={({ field, fieldState, formState }) => (
                                <TextInput
                                    label="Nom"
                                    placeholder="ex. Dupont"
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={formState.isSubmitting}
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                    </Flex>
                    <Controller
                        control={viewModel.form.control}
                        name="phone"
                        render={({ field, fieldState, formState }) => (
                            <TextInput
                                label="Téléphone"
                                icon={<Phone className="w-4 h-4" />}
                                iconWidth={40}
                                placeholder="ex. 06 00 00 00 00"
                                value={field.value}
                                onChange={field.onChange}
                                disabled={formState.isSubmitting}
                                error={fieldState.error?.message}
                            />
                        )}
                    />
                    <Controller
                        control={viewModel.form.control}
                        name="address_1"
                        render={({ field, fieldState, formState }) => (
                            <TextInput
                                label="Adresse"
                                placeholder="ex. 1 rue de la paix"
                                value={field.value}
                                onChange={field.onChange}
                                disabled={formState.isSubmitting}
                                error={fieldState.error?.message}
                            />
                        )}
                    />
                    <Controller
                        control={viewModel.form.control}
                        name="address_2"
                        render={({ field, fieldState, formState }) => (
                            <TextInput
                                label="Complément d'adresse"
                                placeholder="ex. Appartement 1"
                                description="Optionnel"
                                value={field.value || ''}
                                onChange={field.onChange}
                                disabled={formState.isSubmitting}
                                error={fieldState.error?.message}
                            />
                        )}
                    />

                    <Flex gap="sm">
                        <Controller
                            control={viewModel.form.control}
                            name="city"
                            render={({ field, fieldState, formState }) => (
                                <TextInput
                                    label="Ville"
                                    placeholder="ex. Paris"
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={formState.isSubmitting}
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                        <Controller
                            control={viewModel.form.control}
                            name="postal_code"
                            render={({ field, fieldState, formState }) => (
                                <TextInput
                                    label="Code postal"
                                    placeholder="ex. 75000"
                                    value={field.value}
                                    onChange={field.onChange}
                                    disabled={formState.isSubmitting}
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                    </Flex>
                    <Button type="submit" mt="sm">
                        {viewModel.optionsForm.getValues('mode') === 'CREATE'
                            ? "Ajouter l'adresse"
                            : "Modifier l'adresse"}
                    </Button>
                </Stack>
            </Form>
        </Modal>
    )
}

export default CreateShippingAddressModal
